import { Card } from "@/components/ui/card";
import PriceMasterTableView from "./table";
import useDocumentTitle from "@/components/ui/common/document-title";

const PriceMaster = () => {
  useDocumentTitle("Price Master");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <PriceMasterTableView />
      </Card>
    </div>
  );
};

export default PriceMaster;
